import * as React from 'react';

import BomRematchData from './BomRematchData/BomRematchData';
import BomRematchTable from './BomRematchData/BomRematchTable';
import System from "../../../helper/system";
import {useBOMRematchStore} from "../../../hooks/bom_rematch";
import {useEffect} from "react";
import SystemAlerts from 'src/component/SystemAlerts';

const bomId = System.getParams().bomId;

const BomRematchListing = (props) => {
    const [{}, {fetch_static_columns, fetch_saved_preference_by_bom_id, fetch_saved_columns_data_by_bom_id}] = useBOMRematchStore();
    useEffect(() => {
        async function fetchHere() {
            if (bomId !== undefined && bomId !== "") {
                await fetch_static_columns();
                await fetch_saved_preference_by_bom_id({bomId});
                await fetch_saved_columns_data_by_bom_id({bomId});
            } else {
                window.history.back()
            }
        }

        fetchHere()
    }, []);
    return (
        <>
            <div className="container">
                <SystemAlerts />
                <BomRematchData/>
                <BomRematchTable/>
            </div>

        </>
    );
}

export default BomRematchListing;